export const UPDATE_OPZIONE_CONTRATTUALE    = 'UPDATE_OPZIONE_CONTRATTUALE';